const overseasSettlementRouter = {
  route: null,
  name: null,
  title: '出海入驻',
  type: 'folder',
  icon: 'iconfont el-icon-office-building',
  filePath: 'view/overseas_settlement/',
  order: 4,
  inNav: true,
  permission: ['查询入驻申请'],
  children: [
    {
      title: '入驻申请审核',
      type: 'view',
      name: 'overseasSettlementList',
      route: '/overseas-settlement/list',
      filePath: 'view/overseas_settlement/list.vue',
      inNav: true,
      icon: 'iconfont el-icon-tickets',
      permission: ['查询入驻申请'],
    },
  ],
}

export default overseasSettlementRouter
